"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _Speaker = _interopRequireDefault(require("@rsuite/icon-font/lib/application/Speaker"));

// Generated by script, don't edit it please.
var Speaker = (0, _createSvgIcon["default"])({
  as: _Speaker["default"],
  ariaLabel: 'speaker',
  category: 'application',
  displayName: 'Speaker'
});
var _default = Speaker;
exports["default"] = _default;
module.exports = exports.default;